import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { AuthService } from '../core/authentication/auth.service';

export const operatorIdResolverFn: ResolveFn<number> = () => {
  const authService = inject(AuthService);
  return of(authService.userWithRoles.user.operatorId);
};
